import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../Icon'
import { ButtonSelect } from '../../../../Select'
import { Switch } from '../../../../Switch'
import { useDocFlowMappingWidgetMappingFields } from '../../../DocFlow.hooks'
import { DocFlowBuildingField } from '../../../DocFlowBuildingField'
import { DocFlowBuildingGroupField } from '../../../DocFlowBuildingGroupField'
import {
  DocFlowMappingAccuracyField,
  DocFlowMappingProcessCell,
} from '../../../DocFlowMapping'

import { DOC_FLOW_MAPPING_WIDGET_INCLUDE_ARCHIVED_FIELD_QA_NAME } from './DocFlowMappingWidgetMappingFields.constants'

import * as styles from './DocFlowMappingWidgetMappingFields.module.css'

import InformationIcon from '../../../../../icons/info.svg'

function DocFlowMappingWidgetMappingFields({
  isLoading,
  widgetDisabled,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    buildingFieldApiParams,
    buildingGroupFieldApiParams,
    handelClearType,
    handleChangeAccuracy,
    handleChangeBuilding,
    handleChangeBuildingGroup,
    handleChangeIncludeArchived,
    handleChangeType,
    includeArchivedDisabled,
    isContractId,
    isName,
    options,
    typeValue,
  } = useDocFlowMappingWidgetMappingFields({
    ...restProps,
    widgetDisabled,
  })

  const isDisabled = widgetDisabled || isLoading

  return (
    <>
      <div className={styles.groupFields}>
        <FormikField
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={ButtonSelect}
          controlProps={{
            contentProps: {
              placeholderProps: {
                text: t('DocumentStapling.MappingWidgetTypePlaceholderKey'),
              },
            },
          }}
          disabled={isDisabled}
          fieldComponentProps={{
            label: t('DocumentStapling.MappingWidgetTypeFieldTitleKey'),
          }}
          name={DocFlowMappingProcessCell.MappingType}
          options={options}
          onChange={handleChangeType}
          onClear={handelClearType}
        />
        {isContractId || isName ? (
          <>
            <DocFlowBuildingGroupField
              apiParams={buildingGroupFieldApiParams}
              disabled={isDisabled}
              name={DocFlowMappingProcessCell.MappingBuildingGroup}
              placeholder={t(
                'DocumentStapling.MappingWidgetAddBuildingGroupFieldPlaceholderKey'
              )}
              onChange={handleChangeBuildingGroup}
              onClear={handleChangeBuildingGroup}
            />
            <DocFlowBuildingField
              apiParams={buildingFieldApiParams}
              disabled={isDisabled}
              name={DocFlowMappingProcessCell.MappingBuilding}
              placeholder={t(
                'DocumentStapling.MapingWidgetAddBuildingFieldPlaceholderKey'
              )}
              onChange={handleChangeBuilding}
              onClear={handleChangeBuilding}
            />
            <div className={styles.includeArchivedField}>
              <FormikField
                Component={Switch}
                Field={Fragment}
                disabled={isDisabled || includeArchivedDisabled}
                label={t('DocFlow.MappingWidgetIncludeArchivedFieldLabelKey')}
                name={DocFlowMappingProcessCell.MappingIncludeArchived}
                qaName={DOC_FLOW_MAPPING_WIDGET_INCLUDE_ARCHIVED_FIELD_QA_NAME}
                onChange={handleChangeIncludeArchived}
              />
              <IconWithTooltip
                Icon={InformationIcon}
                className={styles.includeArchivedInfoIcon}
                size={ICON_HEIGHT_16}
                tooltip={t('DocFlow.MappingWidgetIncludeArchivedFieldInfoKey')}
              />
            </div>
          </>
        ) : null}
      </div>
      {typeValue?.value ? (
        <DocFlowMappingAccuracyField
          disabled={isDisabled}
          name={DocFlowMappingProcessCell.MappingMatchAccuracy}
          onChange={handleChangeAccuracy}
        />
      ) : null}
    </>
  )
}

export default DocFlowMappingWidgetMappingFields
